// =============================================
// Estúdio de Criação — um "mundo" dentro do marketing (mesmo padrão da Central
// de Compras do Portal Comercial): mesmo app, mesmo login, mesmos dados; quando o
// endereço começa com /estudio, o layout troca menu, cores e título.
// Dentro dele a gerente escolhe a campanha e trabalha nas três peças (stories,
// pôster, catálogo) com a identidade da campanha subida uma vez só.
// =============================================
export const BASE_ESTUDIO = '/estudio';

export const estaNoEstudio = (pathname) =>
  pathname === BASE_ESTUDIO || String(pathname || '').startsWith(`${BASE_ESTUDIO}/`);

// Abas de uma campanha no Estúdio (a ordem é a da tela).
export const ABAS_ESTUDIO = ['identidade', 'stories', 'poster', 'catalogo'];
export const linkEstudio = (id, aba) => `${BASE_ESTUDIO}/${id}${aba ? `?aba=${aba}` : ''}`;

// Últimas campanhas abertas no Estúdio (menu lateral, troca rápida). Só neste computador.
const CHAVE = 'estudio-recentes';
export function campanhasRecentes() {
  try { return JSON.parse(localStorage.getItem(CHAVE) || '[]'); } catch { return []; }
}
export function lembrarCampanha(c) {
  if (!c?.id) return;
  try {
    const lista = [{ id: c.id, nome: c.nome }, ...campanhasRecentes().filter(x => x.id !== c.id)].slice(0, 6);
    localStorage.setItem(CHAVE, JSON.stringify(lista));
    window.dispatchEvent(new Event('estudio-recentes'));
  } catch { /* sem localStorage: o menu só não lembra */ }
}
